import warningIconUrl from "../dashboard/icons/warning.svg"

type WarningIndicatorProps = {
  large?: boolean
  label?: string
  title?: string
}

export function WarningIndicator({
  label = "Under Review",
  large = false,
  title = "Under Review - Check with Consultant",
}: WarningIndicatorProps) {
  return (
    <span
      aria-label={title}
      className={`inline-flex shrink-0 items-center rounded-full bg-[#fde8e7] text-[#8f302f] ${large ? "h-7 gap-1.5 px-2.5" : "h-6 gap-1 px-2"}`}
      role="img"
      title={title}
    >
      <img alt="" className={`block ${large ? "h-4 w-4" : "h-3.5 w-3.5"}`} src={warningIconUrl} />
      <span className={`font-medium [line-height:normal] ${large ? "text-xs" : "text-[11.5px]"}`}>
        {label}
      </span>
    </span>
  )
}
